import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo-section">
          <h1 className="app-title">
            AI Face Emotion Detector
          </h1>
          <p className="app-subtitle">
            Explore your emotions with intention and curiosity
          </p>
        </div>
        
        <div className="brand-section">
          <div className="brand-info">
            <span className="powered-by">Powered by</span>
            <span className="brand-name">Sutralink</span>
          </div>
        </div>
      </div>
      
      <div className="privacy-badge">
        <span className="privacy-icon">🔒</span>
        <span className="privacy-text">100% Private • Client-Side Processing</span>
      </div>
    </header>
  )
}

export default Header 